module.exports = __webpack_public_path__ + "img/channel.2508d262.png";